/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum HistoricoSolicitacoesAliases {
  ALTERACAO_VINCULO_ROUTE = 'alteracao-vinculo-route',
  AUTOCOMPLETE_MENU = 'autocomplete-menu',
  COMPARTILHAR_RISCO_ROUTE = 'compartilhar-risco-route',
  CONSULTAR_ALTERACAO_CADASTRAL_FRAGMENT = 'consultar-alteracao-cadastral-fragment',
  CONSULTAR_ALTERACAO_CADASTRAL_HISTORICO_FRAGMENT = 'consultar-alteracao-cadastral-historico-fragment',
  CONSULTAR_ALTERACAO_CADASTRAL_HISTORICO_ROUTE = 'consultar-alteracao-cadastral-historico-route',
  CONSULTAR_ALTERACAO_CADASTRAL_ROUTE = 'consultar-alteracao-cadastral-route',
  CONSULTAR_ALTERACAO_DATA_ADMISSAO = 'consultar-alteracao-data-admissao',
  CONSULTAR_ALTERACAO_DATA_ADMISSAO_FRAGMENT = 'consultar-alteracao-data-admissao-fragment',
  CONSULTAR_ALTERACAO_LOCALIZACAO_FRAGMENT = 'consultar-alteracao-localizacao-fragment',
  CONSULTAR_ALTERACAO_LOCALIZACAO_ROUTE = 'consultar-alteracao-localizacao-route',
  CONSULTAR_ALTERACAO_MATRICULA = 'consultar-alteracao-matricula',
  CONSULTAR_ALTERACAO_MATRICULA_FRAGMENT = 'consultar-alteracao-matricula-fragment',
  CONSULTAR_ALTERACAO_PRODUTO_FRAGMENT = 'consultar-alteracao-produto-fragment',
  CONSULTAR_ALTERACAO_PRODUTO_ROUTE = 'consultar-alteracao-produto-route',
  CONSULTAR_ALTERACAO_SUBESTIPULANTE_FRAGMENT = 'consultar-alteracao-subestipulante-fragment',
  CONSULTAR_ALTERACAO_SUBESTIPULANTE_ROUTE = 'consultar-alteracao-subestipulante-route',
  CONSULTAR_INCLUSOES_BENEFICIARIO_FRAGMENT = 'consultar-inclusoes-beneficiario-fragment',
  CONSULTAR_INCLUSOES_BENEFICIARIO_ROUTE = 'consultar-inclusoes-beneficiario-route',
  CONSULTAR_MIGRACAO_CONTRATO_FRAGMENT = 'consultar-migracao-contrato-fragment',
  CONSULTAR_MIGRACAO_CONTRATO_ROUTE = 'consultar-migracao-contrato-route',
  CONSULTAR_STATUS_VIA_FRAGMENT = 'consultar-status-via-fragment',
  CONSULTAR_STATUS_VIA_ROUTE = 'consultar-status-via-route',
  CONSULTAR_TRANSFERENCIA_TITULARIDADE = 'consultar-transferencia-titularidade',
  CONSULTAR_TRANSFERENCIA_TITULARIDADE_FRAGMENT = 'consultar-transferencia-titularidade-fragment',
  DROP_DOWN_USUARIO = 'drop-down-usuario',
  FETCH_MENU = 'fetch-menu',
  FIELD_MENU = 'field-menu',
  FORM_MENU = 'form-menu',
  FRAGMENT_0 = 'fragment-0',
  FRAGMENT_COMPARTILHAR_RISCO = 'fragment-compartilhar-risco',
  LAYOUT_1 = 'layout-1',
  LAYOUT_HISTORICO = 'layout-historico',
  MAPPER_MENU = 'mapper-menu',
  OPTION_ALTERACAO_CADASTRAL = 'option-alteracao-cadastral',
  OPTION_ALTERACAO_DATA_ADMISSAO = 'option-alteracao-data-admissao',
  OPTION_ALTERACAO_MATRICULA = 'option-alteracao-matricula',
  OPTION_ALTERACAO_PRODUTO = 'option-alteracao-produto',
  OPTION_ALTERACAO_PRODUTO_T = 'option-alteracao-produto_t',
  OPTION_ALTERACAO_SUBESTIPULANTE = 'option-alteracao-subestipulante',
  OPTION_ALTERACAO_VINCULO = 'option-alteracao-vinculo',
  OPTION_ALTERAR_LOCALIZACAO = 'option-alterar-localizacao',
  OPTION_COMPARTILHAMENTO_RISCO = 'option-compartilhamento-risco',
  OPTION_INCLUSAO_BENEFICIARIO = 'option-inclusao-beneficiario',
  OPTION_MIGRACAO_CONTRATO = 'option-migracao-contrato',
  OPTION_SEGUNDA_VIA = 'option-segunda-via',
  OPTION_TRANSFERENCIA_TITULARIDADE = 'option-transferencia-titularidade',
  PANEL_0 = 'panel-0',
  PANEL_1 = 'panel-1',
  PANEL_CONTENT = 'panel-content',
  PANEL_OLD_MNEU = 'panel-old-mneu',
  TEXT_0 = 'text-0',
  TEXT_MENU = 'text-menu',
  TEXT_MENUS = 'text-menus',
}
export { HistoricoSolicitacoesAliases };
